import React from 'react';

const DocumentationPage = () => {
  return <div></div>;
};

export default DocumentationPage;
